/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StatAggregateDataPoint } from './StatAggregateDataPoint';
import {
    StatAggregateDataPointFromJSON,
    StatAggregateDataPointFromJSONTyped,
    StatAggregateDataPointToJSON,
} from './StatAggregateDataPoint';

/**
 * 
 * @export
 * @interface StatsGetResponse
 */
export interface StatsGetResponse {
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    created_persons?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    deleted_persons?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    active_persons?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsGetResponse
     */
    active_persons_total?: number;
    /**
     * 
     * @type {number}
     * @memberof StatsGetResponse
     */
    persons_failed_authentication_total?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    returning_persons?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsGetResponse
     */
    returning_persons_total?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    authentications?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    successful_authentications?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    successful_mfa?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    failed_authentications?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {{ [key: string]: Array<StatAggregateDataPoint>; }}
     * @memberof StatsGetResponse
     */
    failed_authentications_by_reason?: { [key: string]: Array<StatAggregateDataPoint>; };
    /**
     * 
     * @type {{ [key: string]: Array<StatAggregateDataPoint>; }}
     * @memberof StatsGetResponse
     */
    failed_authentications_by_handle_type?: { [key: string]: Array<StatAggregateDataPoint>; };
    /**
     * 
     * @type {{ [key: string]: Array<StatAggregateDataPoint>; }}
     * @memberof StatsGetResponse
     */
    failed_authentications_by_auth_method?: { [key: string]: Array<StatAggregateDataPoint>; };
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    failed_mfa?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsGetResponse
     */
    person_retention?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    gate_server_starts?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    gate_requests_handled?: Array<StatAggregateDataPoint>;
}

/**
 * Check if a given object implements the StatsGetResponse interface.
 */
export function instanceOfStatsGetResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatsGetResponseFromJSON(json: any): StatsGetResponse {
    return StatsGetResponseFromJSONTyped(json, false);
}

export function StatsGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatsGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'created_persons': !exists(json, 'created_persons') ? undefined : ((json['created_persons'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'deleted_persons': !exists(json, 'deleted_persons') ? undefined : ((json['deleted_persons'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'active_persons': !exists(json, 'active_persons') ? undefined : ((json['active_persons'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'active_persons_total': !exists(json, 'active_persons_total') ? undefined : json['active_persons_total'],
        'persons_failed_authentication_total': !exists(json, 'persons_failed_authentication_total') ? undefined : json['persons_failed_authentication_total'],
        'returning_persons': !exists(json, 'returning_persons') ? undefined : ((json['returning_persons'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'returning_persons_total': !exists(json, 'returning_persons_total') ? undefined : json['returning_persons_total'],
        'authentications': !exists(json, 'authentications') ? undefined : ((json['authentications'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'successful_authentications': !exists(json, 'successful_authentications') ? undefined : ((json['successful_authentications'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'successful_mfa': !exists(json, 'successful_mfa') ? undefined : ((json['successful_mfa'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'failed_authentications': !exists(json, 'failed_authentications') ? undefined : ((json['failed_authentications'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'failed_authentications_by_reason': !exists(json, 'failed_authentications_by_reason') ? undefined : json['failed_authentications_by_reason'],
        'failed_authentications_by_handle_type': !exists(json, 'failed_authentications_by_handle_type') ? undefined : json['failed_authentications_by_handle_type'],
        'failed_authentications_by_auth_method': !exists(json, 'failed_authentications_by_auth_method') ? undefined : json['failed_authentications_by_auth_method'],
        'failed_mfa': !exists(json, 'failed_mfa') ? undefined : ((json['failed_mfa'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'person_retention': !exists(json, 'person_retention') ? undefined : json['person_retention'],
        'gate_server_starts': !exists(json, 'gate_server_starts') ? undefined : ((json['gate_server_starts'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'gate_requests_handled': !exists(json, 'gate_requests_handled') ? undefined : ((json['gate_requests_handled'] as Array<any>).map(StatAggregateDataPointFromJSON)),
    };
}

export function StatsGetResponseToJSON(value?: StatsGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'created_persons': value.created_persons === undefined ? undefined : ((value.created_persons as Array<any>).map(StatAggregateDataPointToJSON)),
        'deleted_persons': value.deleted_persons === undefined ? undefined : ((value.deleted_persons as Array<any>).map(StatAggregateDataPointToJSON)),
        'active_persons': value.active_persons === undefined ? undefined : ((value.active_persons as Array<any>).map(StatAggregateDataPointToJSON)),
        'active_persons_total': value.active_persons_total,
        'persons_failed_authentication_total': value.persons_failed_authentication_total,
        'returning_persons': value.returning_persons === undefined ? undefined : ((value.returning_persons as Array<any>).map(StatAggregateDataPointToJSON)),
        'returning_persons_total': value.returning_persons_total,
        'authentications': value.authentications === undefined ? undefined : ((value.authentications as Array<any>).map(StatAggregateDataPointToJSON)),
        'successful_authentications': value.successful_authentications === undefined ? undefined : ((value.successful_authentications as Array<any>).map(StatAggregateDataPointToJSON)),
        'successful_mfa': value.successful_mfa === undefined ? undefined : ((value.successful_mfa as Array<any>).map(StatAggregateDataPointToJSON)),
        'failed_authentications': value.failed_authentications === undefined ? undefined : ((value.failed_authentications as Array<any>).map(StatAggregateDataPointToJSON)),
        'failed_authentications_by_reason': value.failed_authentications_by_reason,
        'failed_authentications_by_handle_type': value.failed_authentications_by_handle_type,
        'failed_authentications_by_auth_method': value.failed_authentications_by_auth_method,
        'failed_mfa': value.failed_mfa === undefined ? undefined : ((value.failed_mfa as Array<any>).map(StatAggregateDataPointToJSON)),
        'person_retention': value.person_retention,
        'gate_server_starts': value.gate_server_starts === undefined ? undefined : ((value.gate_server_starts as Array<any>).map(StatAggregateDataPointToJSON)),
        'gate_requests_handled': value.gate_requests_handled === undefined ? undefined : ((value.gate_requests_handled as Array<any>).map(StatAggregateDataPointToJSON)),
    };
}

